module.exports = __webpack_public_path__ + "img/figure1.0bfe8e36.png";